import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
            平台特色
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            为什么选择天美影视
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            三大核心优势，打造极致追剧体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="bg-background-50 rounded-xl p-6 md:p-8 border border-background-200/60 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-5 flex items-center justify-center rounded-2xl bg-primary-50">
                <i className={`${feature.icon} text-primary-500 text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-900 mb-3 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}